import { CountryInterface } from "../interfaces";

export function mapCountryFromDtoArray(dto: {
  code: string;
  translations: Array<{ language: string; name: string }>;
}[]): CountryInterface[] {
    return dto.map(item => ({
      shortCode: item.code,
      name: (item.translations?.[0]?.name) ? item.translations[0].name : item.code
    }));
  }
